import { render } from "./Facturatie.vue?vue&type=template&id=10608d89&scoped=true"
import script from "./Facturatie.vue?vue&type=script&lang=js"
export * from "./Facturatie.vue?vue&type=script&lang=js"

import "./Facturatie.vue?vue&type=style&index=0&id=10608d89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10608d89"]])

export default __exports__